export default {   
    all: function() {
        return window.axios.get(`lpas`);
    },
    get: function (id) {
        return window.axios.get(`lpas/${id}`);
    },
    store: function (data) {
        return window.axios.post(`lpas`, data);
    },
    update: function (id, data) {
        return window.axios.put(`lpas/${id}`, data);
    },
    destroy: function (id) {
        return window.axios.delete(`lpas/${id}`);
    },
    canDelete: function (id) {
        return window.axios.get(`lpas/${id}/deletable`);
    },
}